export enum CampaignCreationMode {
  MANUAL = "MANUAL",
  AUTO = "AUTO",
}
